import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "px-6 pt-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text-center mb-4" }, [
  /*#__PURE__*/_createVNode("img", {
    src: "https://images.empoweredconsumerism-static-files.com/ecp/MG_PAY_PC.png",
    alt: "MG Pay",
    class: "seq-mgpay-logo"
  })
], -1)
const _hoisted_3 = { class: "row g-3 mb-4" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_8 = { class: "seq-encash-banner" }
const _hoisted_9 = { class: "seq-encash-banner__icon svg-icon svg-icon-2" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "seq-encash-banner__text" }, [
  /*#__PURE__*/_createVNode("span", { class: "seq-encash-banner__title" }, "Reload your MG Pay"),
  /*#__PURE__*/_createVNode("span", { class: "seq-encash-banner__desc" }, "Choose a top-up source and amount, then confirm before proceeding.")
], -1)
const _hoisted_11 = { class: "card-body py-3" }
const _hoisted_12 = {
  key: 0,
  class: "col-xxl-12"
}
const _hoisted_13 = { class: "mw-500px mx-auto" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label" }, "Top-up source", -1)
const _hoisted_15 = { class: "seq-amount-field mb-5" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "seq-amount-field__label" }, "Source", -1)
const _hoisted_17 = { class: "seq-amount-field__side" }
const _hoisted_18 = /*#__PURE__*/_createVNode("option", { value: 0 }, "Select source", -1)
const _hoisted_19 = { value: 1 }
const _hoisted_20 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label" }, "Quick amounts", -1)
const _hoisted_21 = { class: "seq-amount-chips seq-amount-chips--2 mb-4" }
const _hoisted_22 = { class: "seq-breakdown" }
const _hoisted_23 = { class: "seq-breakdown__row seq-breakdown__row--total" }
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "seq-breakdown__label" }, "TOTAL", -1)
const _hoisted_25 = { class: "seq-breakdown__value" }
const _hoisted_26 = {
  key: 0,
  class: "row mb-5"
}
const _hoisted_27 = { class: "col-md-12 fv-row py-1 text-center" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Proceed")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Processing...")
const _hoisted_31 = {
  key: 1,
  class: "row mb-5"
}
const _hoisted_32 = { class: "col-md-12 fv-row py-1 text-center" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Proceed")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Processing...")
const _hoisted_36 = {
  key: 1,
  class: "col-xxl-12"
}
const _hoisted_37 = { class: "mw-500px mx-auto text-center py-5" }
const _hoisted_38 = /*#__PURE__*/_createVNode("h3", { class: "seq-otp-title fs-2" }, "Verify your MG Pay reload", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("p", { class: "seq-otp-subtitle" }, "Please enter the OTP sent to your mobile phone.", -1)
const _hoisted_40 = { class: "my-8" }
const _hoisted_41 = { class: "d-grid col-10 col-sm-8 mx-auto" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Verify")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Processing...")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_StatCard = _resolveComponent("StatCard")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_OtpInput = _resolveComponent("OtpInput")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 8,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card seq-card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _withDirectives(_createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_StatCard, {
              compact: "",
              label: `${_ctx.user.usid} Balance`,
              icon: "media/icons/duotone/Shopping/Money.svg",
              value: _ctx.balancedetails.balance,
              "currency-symbol": _ctx.balancedetails.currency || '',
              period: "",
              decimals: 2
            }, null, 8, ["label", "value", "currency-symbol"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_StatCard, {
              compact: "",
              label: "MG Pay",
              icon: "media/icons/duotone/Shopping/Wallet.svg",
              value: _ctx.balancedetails.matchinpaybalance,
              "currency-symbol": _ctx.balancedetails.currency || '',
              period: "",
              decimals: 2
            }, null, 8, ["value", "currency-symbol"])
          ])
        ], 512), [
          [_vShow, !_ctx.loadingBalance]
        ]),
        _withDirectives(_createVNode("div", _hoisted_6, [
          _createVNode(_component_el_skeleton, {
            rows: 2,
            animated: ""
          })
        ], 512), [
          [_vShow, _ctx.loadingBalance]
        ]),
        (_ctx.hasPendingMatchinPayOTP == false)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("span", _hoisted_9, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Wallet.svg" })
                ]),
                _hoisted_10
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_11, [
        (_ctx.hasPendingMatchinPayOTP == false)
          ? (_openBlock(), _createBlock("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode("div", _hoisted_17, [
                    _withDirectives(_createVNode("select", {
                      class: "seq-amount-field__select",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.topupfrom = $event)),
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectTopUpFrom()))
                    }, [
                      _hoisted_18,
                      _createVNode("option", _hoisted_19, _toDisplayString(_ctx.user.usid) + " Balance", 1)
                    ], 544), [
                      [_vModelSelect, _ctx.topupfrom]
                    ])
                  ])
                ]),
                _hoisted_20,
                _createVNode("div", _hoisted_21, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.amounts, (amount) => {
                    return (_openBlock(), _createBlock("button", {
                      key: amount,
                      type: "button",
                      class: ["seq-amount-chip", { 'seq-amount-chip--active': _ctx.totalAmount2 === amount }],
                      onClick: ($event: any) => (_ctx.computeTotalAmount(amount))
                    }, _toDisplayString(_ctx.numberWithCommas(Number(amount).toFixed(2))), 11, ["onClick"]))
                  }), 128))
                ]),
                _createVNode("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode("span", _hoisted_25, _toDisplayString(_ctx.numberWithCommas(_ctx.totalAmount)) + " " + _toDisplayString(_ctx.currency), 1)
                  ])
                ]),
                (_ctx.topupfrom == 1)
                  ? (_openBlock(), _createBlock("div", _hoisted_26, [
                      _createVNode("div", _hoisted_27, [
                        (_ctx.isShowProceed)
                          ? (_openBlock(), _createBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-sm btn-seq-blue min-w-100px",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancel_matchinpayReload()))
                            }, " Reset "))
                          : _createCommentVNode("", true),
                        _hoisted_28,
                        (_ctx.isShowProceed)
                          ? (_openBlock(), _createBlock("button", {
                              key: 1,
                              type: "button",
                              class: "btn btn-sm btn-seq-green min-w-100px",
                              disabled: _ctx.isProcessingReload,
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.process_matchinpayReload()))
                            }, [
                              (_ctx.isProcessingReload == false)
                                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                    _hoisted_29
                                  ], 64))
                                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                    _hoisted_30
                                  ], 64))
                            ], 8, ["disabled"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.topupfrom == 2)
                  ? (_openBlock(), _createBlock("div", _hoisted_31, [
                      _createVNode("div", _hoisted_32, [
                        (_ctx.isShowProceed)
                          ? (_openBlock(), _createBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-sm btn-seq-blue min-w-100px",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cancel_matchinpayReload()))
                            }, " Reset "))
                          : _createCommentVNode("", true),
                        _hoisted_33,
                        (_ctx.isShowProceed)
                          ? (_openBlock(), _createBlock("button", {
                              key: 1,
                              type: "button",
                              class: "btn btn-sm btn-seq-green min-w-100px",
                              disabled: _ctx.isProcessingReload,
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.process_matchinpayReload_DLQR()))
                            }, [
                              (_ctx.isProcessingReload == false)
                                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                    _hoisted_34
                                  ], 64))
                                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                    _hoisted_35
                                  ], 64))
                            ], 8, ["disabled"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_36, [
              _createVNode("div", _hoisted_37, [
                _hoisted_38,
                _hoisted_39,
                _createVNode("div", _hoisted_40, [
                  _createVNode(_component_OtpInput, {
                    modelValue: _ctx.model_matchinpay_otp,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.model_matchinpay_otp = $event)),
                    length: 6,
                    disabled: _ctx.isProcessingOTP
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _createVNode("div", _hoisted_41, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-seq-blue",
                    disabled: _ctx.isProcessingOTP,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.process_matchinpayOTP()))
                  }, [
                    (_ctx.isProcessingOTP == false)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _hoisted_42
                        ], 64))
                      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _hoisted_43
                        ], 64))
                  ], 8, ["disabled"])
                ])
              ])
            ]))
      ])
    ], 2), [
      [_vShow, !_ctx.loading && _ctx.isAllowedMatchinPay]
    ])
  ], 64))
}